/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
export const useToggle = (defaultValue) => {
    const [active, setActive] = React.useState(defaultValue || false);
    const activate = React.useCallback(() => {
        setActive(true);
    }, []);
    const deactivate = React.useCallback(() => {
        setActive(false);
    }, []);
    const toggle = React.useCallback(() => {
        setActive(active => !active);
    }, []);
    return { active, activate, deactivate, toggle };
};
